import UserSnap from './UserSnap';

export default UserSnap;
